import { useState } from 'react'
import { constants, TABLE_TYPE_DEFAULT_VALUE } from '../../Constants/constants'
import { useSelector, useDispatch } from 'react-redux'
import _ from 'lodash'

import { Tooltip, IconButton } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import FileCopyIcon from '@mui/icons-material/FileCopy'
import CancelIcon from '@mui/icons-material/Cancel'
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid'

import Iconify from '../../Component/common/iconify/Iconify'
import { ICONIFY } from '../../Constants/iconify'

import { BaseWrapper } from '../../Component/BaseWrapper'
import { setQueueTemplate, setQueueTemplateTimeSectionValue, setQueueTemplateTableTypeValue } from '../../actions/queueTemplateAction'
import { setLoading } from '../../actions/systemAction'
import { TempBtn } from '../../Component/Input/TempBtn'
import QueueTemplateValidation from '../../validations/queueTemplateValidation'
import { queueTemplateValidationConstants } from '../../Constants/validationConstants'
import { getString } from '../../helper/util'
import { QueueTemplateAutoTaskDialog, AUTO_TASK_DEFAULT_ITEM } from './QueueTemplateAutoTaskDialog'

import '../../styles/queueTemplate.scss'
import {
  getDefaultTableType,
  getReAssignDefaultColorTableTypeList,
  getTableTypeID,
  getTimeSectionID,
  reorderTableTypeList,
  reorderTimeSectionList,
  sortList,
} from './queueTemplateUtil'
import { QueueTemplateTimeSectionListDragAndDropSection } from './QueueTemplateTimeSectionListDragNDrop/QueueTemplateTimeSectionListDragAndDropSection'

export const QueueTemplateTimeSectionList = ({
  resource,
  setSelectedType,
  setCustomIdNumber,
  customIdNumber,
  tableTypeColorList,
  defaultTableTypeColorList,
}) => {
  const dispatch = useDispatch()
  const savedTimeSection = useSelector((state) => state.queueTemplate.ui.timeSection)
  const savedTableType = useSelector((state) => state.queueTemplate.ui.tableType)
  const savedQueueTemplate = useSelector((state) => state.queueTemplate.ui.queueTemplate)
  const savedTableTypeColorList = useSelector((state) => state.queueTemplate.ui.tableTypeColorList)
  const savedDefaultTableTypeColorList = useSelector((state) => state.queueTemplate.ui.defaultTableTypeColorList)
  const lang = useSelector((state) => state.lang.ui.lang)
  const theme = useSelector((state) => state.theme.ui.theme)

  const [errorVersion, setErrorVersion] = useState(QueueTemplateValidation.getVersion())

  const [autoTaskDialog, setAutoTaskDialog] = useState({
    open: false,
    initialAutoTaskList: [],
    tableTypeOptions: [],
    existingAutoTaskRows: [],
  })

  function handleAddQueueTemplateList() {
    const tempQueueTemplate = _.cloneDeep(savedQueueTemplate)
    const newQueueTemplateInput = _.cloneDeep(constants.TIME_SECTION_DEFAULT_VALUE)
    const newTableTypeInput = _.cloneDeep(TABLE_TYPE_DEFAULT_VALUE)
    let newCustomIdNumber = _.cloneDeep(customIdNumber)
    newQueueTemplateInput.customId = 'section_' + newCustomIdNumber
    newQueueTemplateInput.timeSectionId = getTimeSectionID(tempQueueTemplate)
    newCustomIdNumber = newCustomIdNumber + 1
    tempQueueTemplate.push(newQueueTemplateInput)
    dispatch(setQueueTemplateTableTypeValue(newTableTypeInput))
    dispatch(setQueueTemplateTimeSectionValue(newQueueTemplateInput))
    dispatch(setQueueTemplate(tempQueueTemplate))
    setSelectedType('timeSection')
    setCustomIdNumber(newCustomIdNumber + 1)
    QueueTemplateValidation.validateTemplateTimeSection(tempQueueTemplate)
  }

  function handleAddTableTypeList(item) {
    const newItem = _.cloneDeep(item)
    const tempQueueTemplate = _.cloneDeep(savedQueueTemplate)
    let tempTableTypeIndex = tempQueueTemplate.findIndex((tempQueueTemplateValue) => tempQueueTemplateValue.customId === newItem.customId)
    let tempTableType = tempQueueTemplate.find((tempQueueTemplateValue) => tempQueueTemplateValue.customId === newItem.customId)
    const newTableType = _.cloneDeep(
      getDefaultTableType(
        tempQueueTemplate[tempTableTypeIndex],
        tempQueueTemplate[tempTableTypeIndex].tableTypeList?.length,
        savedTableTypeColorList || defaultTableTypeColorList
      )
    )
    const newQueueTemplateInput = _.cloneDeep(constants.TIME_SECTION_DEFAULT_VALUE)
    newTableType.id = null
    newTableType.timeSectionCustomId = tempTableType.customId
    newTableType.customId = 'table_' + customIdNumber
    const sortedList = sortList(tempQueueTemplate[tempTableTypeIndex].tableTypeList)
    // newTableType.tableType = getTableTypeID(sortedList)
    newTableType.tableType = {
      tableType: getTableTypeID(sortedList),
    }

    tempQueueTemplate[tempTableTypeIndex].tableTypeList.push(newTableType)

    dispatch(setQueueTemplateTableTypeValue(newTableType))
    dispatch(setQueueTemplateTimeSectionValue(newQueueTemplateInput))
    dispatch(setQueueTemplate(tempQueueTemplate))
    setSelectedType('tableType')
    setCustomIdNumber(customIdNumber + 1)
    QueueTemplateValidation.validateTemplateTableType(tempQueueTemplate)
  }

  function handleCloneQueueTemplate(item) {
    const tempQueueTemplate = _.cloneDeep(savedQueueTemplate)
    const newTableTypeInput = _.cloneDeep(TABLE_TYPE_DEFAULT_VALUE)
    const newItem = _.cloneDeep(item)
    let newCustomIdNumber = _.cloneDeep(customIdNumber)
    newItem.id = null
    newItem.customId = 'section_' + newCustomIdNumber
    newItem.timeSectionId = ''
    newCustomIdNumber = newCustomIdNumber + 1
    newItem.tableTypeList.forEach((tableType) => {
      tableType.id = null
      tableType.timeSectionCustomId = newItem.customId
      tableType.customId = 'table_' + newCustomIdNumber
      newCustomIdNumber = newCustomIdNumber + 1
    })
    tempQueueTemplate.push(newItem)
    dispatch(setQueueTemplateTableTypeValue(newTableTypeInput))
    dispatch(setQueueTemplateTimeSectionValue(newItem))
    dispatch(setQueueTemplate(tempQueueTemplate))
    setSelectedType('timeSection')
    setCustomIdNumber(newCustomIdNumber + 1)
    QueueTemplateValidation.validateTemplateTimeSection(tempQueueTemplate)
  }

  function handleCloneTableType(item, tableType) {
    const newItem = _.cloneDeep(item)
    const newTableType = _.cloneDeep(tableType)
    const tempQueueTemplate = _.cloneDeep(savedQueueTemplate)
    let tempTableTypeIndex = tempQueueTemplate.findIndex((tempQueueTemplateValue) => tempQueueTemplateValue.customId === newItem.customId)
    let tempTableType = tempQueueTemplate.find((tempQueueTemplateValue) => tempQueueTemplateValue.customId === newItem.customId)
    const newQueueTemplateInput = _.cloneDeep(constants.TIME_SECTION_DEFAULT_VALUE)
    newTableType.id = null
    newTableType.timeSectionCustomId = tempTableType.customId
    newTableType.customId = 'table_' + customIdNumber
    newTableType.tableType = ''
    tempQueueTemplate[tempTableTypeIndex].tableTypeList.push(newTableType)
    tempQueueTemplate[tempTableTypeIndex].tableTypeList = [
      ...getReAssignDefaultColorTableTypeList({
        tableTypeList: tempQueueTemplate[tempTableTypeIndex].tableTypeList,
        startIndex: 0,
        endIndex: tempTableType.tableTypeList.length,
        colorList: savedTableTypeColorList || savedDefaultTableTypeColorList,
      }),
    ]
    dispatch(setQueueTemplateTableTypeValue(newTableType))
    dispatch(setQueueTemplateTimeSectionValue(newQueueTemplateInput))
    dispatch(setQueueTemplate(tempQueueTemplate))
    setSelectedType('tableType')
    setCustomIdNumber((prev) => prev + 1)
    QueueTemplateValidation.validateTemplateTableType(tempQueueTemplate)
  }

  function handleDeleteQueueTemplateList(e, item) {
    e.stopPropagation()
    const newItem = _.cloneDeep(item)
    const tempQueueTemplate = _.cloneDeep(savedQueueTemplate)
    dispatch(setQueueTemplate(tempQueueTemplate.filter((queueTemplate) => newItem.customId !== queueTemplate.customId)))
    QueueTemplateValidation.validateTemplateTimeSection(tempQueueTemplate.filter((queueTemplate) => newItem.customId !== queueTemplate.customId))
    const tempTimeSection = _.cloneDeep(savedTimeSection)
    const tempTableType = _.cloneDeep(savedTableType)
    if (tempTimeSection.customId === newItem.customId) {
      const newQueueTemplateInput = _.cloneDeep(constants.TIME_SECTION_DEFAULT_VALUE)
      dispatch(setQueueTemplateTimeSectionValue(newQueueTemplateInput))
    } else if (tempTableType.timeSectionCustomId === newItem.customId) {
      const newTableTypeInput = _.cloneDeep(TABLE_TYPE_DEFAULT_VALUE)
      dispatch(setQueueTemplateTableTypeValue(newTableTypeInput))
    }
    setSelectedType('')
  }

  function handleDeleteTableTypeList(item, tableType) {
    const newItem = _.cloneDeep(item)
    const newTableType = _.cloneDeep(tableType)
    const tempQueueTemplate = _.cloneDeep(savedQueueTemplate)
    let tempTableTypeIndex = tempQueueTemplate.findIndex((tempQueueTemplateValue) => tempQueueTemplateValue.customId === newItem.customId)
    let tempTableType = tempQueueTemplate.find((tempQueueTemplateValue) => tempQueueTemplateValue.customId === newItem.customId)
    const tempSavedTableType = _.cloneDeep(savedTableType)
    if (tempSavedTableType.customId === newTableType.customId) {
      const newTableTypeInput = _.cloneDeep(TABLE_TYPE_DEFAULT_VALUE)
      dispatch(setQueueTemplateTableTypeValue(newTableTypeInput))
    }
    tempTableType.tableTypeList = tempTableType.tableTypeList.filter((tempTableTypeValue) => newTableType.customId !== tempTableTypeValue.customId)
    tempTableType.tableTypeList = [
      ...getReAssignDefaultColorTableTypeList({
        tableTypeList: tempTableType.tableTypeList,
        startIndex: 0,
        endIndex: tempTableType.tableTypeList.length,
        colorList: savedTableTypeColorList || savedDefaultTableTypeColorList,
      }),
    ]
    tempQueueTemplate[tempTableTypeIndex] = tempTableType
    dispatch(setQueueTemplate(tempQueueTemplate))
    setSelectedType('')
    QueueTemplateValidation.validateTemplateTableType(tempQueueTemplate)
  }

  const handleAutoOrderTableType = (item) => {
    const temptItem = _.cloneDeep(item)
    const tempQueueTemplate = _.cloneDeep(savedQueueTemplate)
    const targetTimesection = tempQueueTemplate.find(
      (timesection) => (timesection.id || timesection.customId) === (temptItem.id || temptItem.customId)
    )
    const targetTimesectionIdx = tempQueueTemplate.findIndex(
      (timesection) => (timesection.id || timesection.customId) === (temptItem.id || temptItem.customId)
    )
    const newTableTypeList = reorderTableTypeList(targetTimesection.tableTypeList, savedTableTypeColorList || savedDefaultTableTypeColorList)

    if (!newTableTypeList) {
      return
    }

    targetTimesection.tableTypeList = newTableTypeList
    tempQueueTemplate[targetTimesectionIdx] = targetTimesection

    const tempSavedTableType = _.cloneDeep(savedTableType)
    tempSavedTableType.tableType = newTableTypeList.find(
      (tableType) => (tableType.id || tableType.customId) === (tempSavedTableType.id || tempSavedTableType.customId)
    )?.tableType
    dispatch(setQueueTemplate(tempQueueTemplate))
    dispatch(setQueueTemplateTableTypeValue(tempSavedTableType))
  }

  const handleAutoOrderTimeSection = () => {
    const tempQueueTemplate = _.cloneDeep(savedQueueTemplate)

    const reorderedQueueTemplate = reorderTimeSectionList(tempQueueTemplate)

    if (!reorderedQueueTemplate) {
      return
    }

    const tempTimeSection = _.cloneDeep(savedTimeSection)
    tempTimeSection.timeSectionId = reorderedQueueTemplate.find(
      (timeSection) => (timeSection.id || timeSection.customId) === (tempTimeSection.id || tempTimeSection.customId)
    )?.timeSectionId

    dispatch(setQueueTemplate(reorderedQueueTemplate))
    dispatch(setQueueTemplateTimeSectionValue(tempTimeSection))
  }

  const getTableTypeIdentifier = (tableType, index) =>
    String(tableType?.customId || tableType?.id || tableType?.tableType?.tableType || `TABLE_TYPE_${index}`)

  const getTableTypeLabel = (tableType, index) =>
    tableType?.tableType?.tableType || tableType?.timeSectionDescription || tableType?.description || `Table Type ${index + 1}`

  const getTableTypeBackgroundColor = (tableType, index) => 
    tableType?.tableType?.displayTableTypeForegroundColor || tableType?.displayTableTypeForegroundColor || '#FFFFFF'

  const getTableTypeForegroundColor = (tableType, index) =>
    tableType?.tableType?.displayTableTypeBackgroundColor || tableType?.displayTableTypeBackgroundColor || '#000000'

  const getTableTypeMinSize = (tableType, index) => 
    tableType?.tableType?.minSize || tableType?.minSize || null

  const getTableTypeMaxSize = (tableType, index) =>
    tableType?.tableType?.maxSize || tableType?.maxSize || null

  function openAutoTaskDialog(item) {
    const sourceTableTypeList = item?.tableTypeList || savedTimeSection.tableTypeList || []

    const existingAutoTaskList =
      sourceTableTypeList.find((tableType) => Array.isArray(tableType.autoTaskList) && tableType.autoTaskList.length > 0)?.autoTaskList || []

    const tableTypeOptions = sourceTableTypeList.map((tableType, index) => ({
      id: getTableTypeIdentifier(tableType, index),
      label: getTableTypeLabel(tableType, index),
      backgroundColor: getTableTypeBackgroundColor(tableType, index),
      foregroundColor: getTableTypeForegroundColor(tableType, index),
      minSize: getTableTypeMinSize(tableType, index),
      maxSize: getTableTypeMaxSize(tableType, index),
    }))

    const existingAutoTaskRows = sourceTableTypeList.flatMap((tableType, tableTypeIndex) => {
      const tableTypeId = getTableTypeIdentifier(tableType, tableTypeIndex)
      const label = getTableTypeLabel(tableType, tableTypeIndex)
      const backgroundColor = getTableTypeBackgroundColor(tableType, tableTypeIndex)
      const foregroundColor = getTableTypeForegroundColor(tableType, tableTypeIndex)
      const minSize = getTableTypeMinSize(tableType, tableTypeIndex)
      const maxSize = getTableTypeMaxSize(tableType, tableTypeIndex)
      const tableTypeAutoTaskList = Array.isArray(tableType.autoTaskList) ? tableType.autoTaskList : []

      return tableTypeAutoTaskList.map((task, taskIndex) => ({
        rowId: `${tableTypeId}::${task?.id || 'idx'}::${taskIndex}`,
        tableTypeId,
        label,
        backgroundColor,
        foregroundColor,
        minSize,
        maxSize,
        taskIndex,
        taskType: task?.taskType,
        executionType: task?.executionType,
        value: task?.executionExactDateTime || task?.executionResetTime || task?.executionOffsetMinute || '',
        status: task?.status,
      }))
    })

    setAutoTaskDialog({
      open: true,
      initialAutoTaskList: _.cloneDeep([AUTO_TASK_DEFAULT_ITEM]),
      tableTypeOptions,
      existingAutoTaskRows,
    })
  }

  function closeAutoTaskDialog() {
    setAutoTaskDialog((previousState) => ({
      ...previousState,
      open: false,
    }))
  }

  function applyAutoTaskListToChildren({
    autoTaskList = [],
    selectedTableTypeIds = [],
    applyAllTableTypes = true,
    operationMode = 'APPEND',
    selectedExistingTaskRefs = [],
  } = {}) {
    const newSavedQueueTemplate = _.cloneDeep(savedQueueTemplate)
    const newSavedTimeSection = _.cloneDeep(savedTimeSection)
    const autoTaskListToApply = _.cloneDeep(autoTaskList)
    const selectedTableTypeIdSet = new Set(selectedTableTypeIds || [])
    const selectedTaskRefByTableTypeId = (selectedExistingTaskRefs || []).reduce((accumulator, currentRef) => {
      if (!currentRef?.tableTypeId && currentRef?.tableTypeId !== 0) {
        return accumulator
      }

      if (!accumulator[currentRef.tableTypeId]) {
        accumulator[currentRef.tableTypeId] = []
      }

      accumulator[currentRef.tableTypeId].push(currentRef.taskIndex)
      return accumulator
    }, {})

    for (const [tableTypeIndex, tableType] of (newSavedTimeSection.tableTypeList || []).entries()) {
      const tableTypeId = getTableTypeIdentifier(tableType, tableTypeIndex)
      const currentAutoTaskList = Array.isArray(tableType.autoTaskList) ? [...tableType.autoTaskList] : []

      if (operationMode === 'DELETE_SELECTED' || operationMode === 'REPLACE_SELECTED') {
        const selectedIndexes = selectedTaskRefByTableTypeId[tableTypeId] || []

        if (selectedIndexes.length === 0) {
          continue
        }

        const selectedIndexSet = new Set(selectedIndexes)
        const remainingAutoTaskList = currentAutoTaskList.filter((_, index) => !selectedIndexSet.has(index))

        if (operationMode === 'DELETE_SELECTED') {
          tableType.autoTaskList = remainingAutoTaskList
          continue
        }

        tableType.autoTaskList = [...remainingAutoTaskList, ..._.cloneDeep(autoTaskListToApply)]
        continue
      }

      if (!applyAllTableTypes && !selectedTableTypeIdSet.has(tableTypeId)) {
        continue
      }

      tableType.autoTaskList = [...currentAutoTaskList, ..._.cloneDeep(autoTaskListToApply)]
    }

    const newTimeSectionIdx = newSavedQueueTemplate.findIndex((timeSection) => savedTimeSection.customId === timeSection.customId)
    if (newTimeSectionIdx >= 0) {
      newSavedQueueTemplate[newTimeSectionIdx] = newSavedTimeSection
    } else {
      newSavedTimeSection.customId = 'section_' + customIdNumber
      setCustomIdNumber(customIdNumber + 1)
      newSavedQueueTemplate.push(newSavedTimeSection)
    }

    dispatch(setQueueTemplateTimeSectionValue(newSavedTimeSection))
    dispatch(setQueueTemplate(newSavedQueueTemplate))

    const newTableTypeInput = _.cloneDeep(TABLE_TYPE_DEFAULT_VALUE)
    dispatch(setQueueTemplateTableTypeValue(newTableTypeInput))

    QueueTemplateValidation.validateTemplateTimeSection(newSavedQueueTemplate)
    setErrorVersion(QueueTemplateValidation.getVersion())
    closeAutoTaskDialog()
  }

  return (
    <div className="queue-template-content-wrapper">
      <BaseWrapper>
        <div className="queue-template-array-list-wrapper no-flex ">
          <div className="sub-title">{getString(lang, resource, 'timeSectionList', theme)} : </div>
          <div className="time-section-button">
            <Tooltip title={getString(lang, resource, 'autoOrderTimeSection', theme)}>
              <IconButton 
                sx={{ backgroundColor: '#e0e0e0' }}
                onClick={(e) => {
                  dispatch(setLoading(true))
                  handleAutoOrderTimeSection()
                  dispatch(setLoading(false))
                }} 
                size="large"
                >
                <Iconify icon={ICONIFY.sort} />
              </IconButton>
            </Tooltip>
            <Tooltip title={getString(lang, resource, 'addQueueTemplate', theme)}>
              <IconButton
                sx={{ backgroundColor: '#e0e0e0' }}
                onClick={() => {
                  handleAddQueueTemplateList()
                }} 
                size="large"
                >
                <Iconify icon={ICONIFY.add} />
              </IconButton>
            </Tooltip>
          </div>
        </div>
        {QueueTemplateValidation.getErrorMessages('timeSection') && QueueTemplateValidation.getErrorMessages('timeSection').length > 0 && (
          <div className="error-message">
            <CancelIcon className="error-message-icon" fontSize={constants.SIZE.SMALL} />
            {QueueTemplateValidation.getErrorMessages('timeSection')}
          </div>
        )}
        <div className="queue-template-content-content">
          <div className="queue-template-tab-background">
            {savedQueueTemplate.map((item, index) => {
              let error = false
              if (
                QueueTemplateValidation.getErrorMessages(queueTemplateValidationConstants.KEY_QUEUE_TEMPLATE_ERROR, item.customId).map((error) => {
                  return error
                }).length > 0 ||
                QueueTemplateValidation.getErrorMessages(queueTemplateValidationConstants.KEY_TABLE_TYPE_LIST, item.customId).map((error) => {
                  return error
                }).length > 0
              ) {
                error = true
              }
              item.tableTypeList.map((tableType) => {
                if (
                  QueueTemplateValidation.getErrorMessages(queueTemplateValidationConstants.KEY_TABLE_TYPE_ERROR, tableType.customId).map((error) => {
                    return error
                  }).length > 0
                ) {
                  error = true
                }
                return tableType
              })
              let list = ''
              list = (
                <div
                  key={item.customId}
                  className={
                    item.customId === savedTimeSection.customId
                      ? 'queue-template-list-item queue-template-selected-product'
                      : error
                      ? 'queue-template-list-item queue-template-error'
                      : 'queue-template-list-item'
                  }
                  onClick={(e) => {
                    dispatch(setLoading(true))
                    e.stopPropagation()
                    dispatch(setQueueTemplateTimeSectionValue(item))
                    const newTableTypeInput = _.cloneDeep(TABLE_TYPE_DEFAULT_VALUE)
                    dispatch(setQueueTemplateTableTypeValue(newTableTypeInput))
                    setSelectedType('timeSection')
                    dispatch(setLoading(false))
                  }}
                >
                  <div className="code">
                    <div>{getString(lang, resource, 'id', theme, theme) + ': ' + item.customId}</div>
                    <div className="type">{getString(lang, resource, 'timeSectionId') + ': ' + item.timeSectionId}</div>
                  </div>
                  <div className="content">
                    <div className="top">
                      <div className="name">
                        {item?.label?.en && <div> EN: {item?.label?.en}</div>}
                        {item?.label?.['zh-HK'] && <div> TC: {item?.label?.['zh-HK']}</div>}
                      </div>
                      <div className="delete-button">
                        <Tooltip title={getString(lang, resource, 'autoOrderTableType', theme)}>
                          <IconButton
                            sx={{ backgroundColor: '#e0e0e0' }}
                            onClick={(e) => {
                              dispatch(setLoading(true))
                              handleAutoOrderTableType(item)
                              dispatch(setLoading(false))
                            }}
                            size="large"
                          >
                            <Iconify icon={ICONIFY.sort} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={getString(lang, resource, 'Clone', theme)}>
                          <IconButton
                            sx={{ backgroundColor: '#e0e0e0' }}
                            onClick={(e) => {
                              dispatch(setLoading(true))
                              handleCloneQueueTemplate(item)
                              dispatch(setLoading(false))
                            }}
                            size="large"
                            >
                            <Iconify icon={ICONIFY.clone} />
                          </IconButton>
                        </Tooltip>
                        
                        <Tooltip title={getString(lang, resource, 'applyAutoTaskBtn', theme)}>
                          <IconButton
                            sx={{ backgroundColor: '#e0e0e0' }}
                            onClick={(e) => {
                              openAutoTaskDialog(item)
                            }}
                            size="large"
                            >
                            <Iconify icon={ICONIFY.applyAutoTaskList} />
                            </IconButton>
                        </Tooltip>
                        {!item.id && (
                          <Tooltip title={getString(lang, resource, 'deleteBtn', theme)}>
                            <IconButton
                              sx={{ backgroundColor: '#e0e0e0' }}
                              onClick={(e) => {
                                dispatch(setLoading(true))
                                handleDeleteQueueTemplateList(e, item)
                                dispatch(setLoading(false))
                              }}
                              size="large"
                            >
                              <Iconify icon={ICONIFY.delete} />
                            </IconButton>
                          </Tooltip>
                        )}
                      </div>
                    </div>
                    <div className="bottom">
                      <QueueTemplateTimeSectionListDragAndDropSection
                        index={index}
                        item={item}
                        setSelectedType={setSelectedType}
                        handleCloneTableType={handleCloneTableType}
                        resource={resource}
                        handleDeleteTableTypeList={handleDeleteTableTypeList}
                      />
                      {(item.status === 'A' || !item.id) && (
                        <TempBtn
                          btnSetting={{
                            className: 'queue-template-button-on-top sub-item-add-button',
                            onClick: (e) => {
                              e.stopPropagation()
                              handleAddTableTypeList(item)
                            },
                            color: constants.STYLE.PRIMARY,
                            variant: constants.STYLE.VARIANT.CONTAINED,
                            label: { resource: resource, key: 'addTableType' },
                            icon: <AddIcon />,
                          }}
                        ></TempBtn>
                      )}
                    </div>
                    {QueueTemplateValidation.getErrorMessages(queueTemplateValidationConstants.KEY_TABLE_TYPE_LIST, item.customId).map((error) => {
                      return error
                    }) &&
                      QueueTemplateValidation.getErrorMessages(queueTemplateValidationConstants.KEY_TABLE_TYPE_LIST, item.customId).map((error) => {
                        return error
                      }).length > 0 && (
                        <div className="error-message">
                          <CancelIcon className="error-message-icon" fontSize={constants.SIZE.SMALL} />
                          {QueueTemplateValidation.getErrorMessages(queueTemplateValidationConstants.KEY_TABLE_TYPE_LIST, item.customId).map(
                            (error) => {
                              return error
                            }
                          )}
                        </div>
                      )}
                    {QueueTemplateValidation.getErrorMessages(queueTemplateValidationConstants.KEY_QUEUE_TEMPLATE_ERROR, item.customId).map(
                      (error) => {
                        return error
                      }
                    ) &&
                      QueueTemplateValidation.getErrorMessages(queueTemplateValidationConstants.KEY_QUEUE_TEMPLATE_ERROR, item.customId).map(
                        (error) => {
                          return error
                        }
                      ).length > 0 && (
                        <div className="error-message">
                          <CancelIcon className="error-message-icon" fontSize={constants.SIZE.SMALL} />
                          {QueueTemplateValidation.getErrorMessages(queueTemplateValidationConstants.KEY_QUEUE_TEMPLATE_ERROR, item.customId).map(
                            (error) => {
                              return error
                            }
                          )}
                        </div>
                      )}
                  </div>
                </div>
              )
              return list
            })}
          </div>
        </div>
      </BaseWrapper>
      <QueueTemplateAutoTaskDialog
        open={autoTaskDialog.open}
        resource={resource}
        tableTypeOptions={autoTaskDialog.tableTypeOptions}
        initialAutoTaskList={autoTaskDialog.initialAutoTaskList}
        existingAutoTaskRows={autoTaskDialog.existingAutoTaskRows}
        onClose={closeAutoTaskDialog}
        onApply={applyAutoTaskListToChildren}
      />
    </div>
  )
}
